import { SensorStatus } from '@/models/sensor-status'

export class SensorDetails{
  battery?: number
  latestDateTime?: string
  status?: SensorStatus
  rssi?: number

  constructor(params?: Partial<SensorDetails>) {
    Object.assign(this, params)
  }
}
